// extracted by mini-css-extract-plugin
module.exports = {"container":"wuu2JIhzPDLsMpYAiwSe","leftSide":"tbctl2kIPdqHJPaCyooQ","rightSide":"CMYq222GZkTnhZvlt84s","haveAccount":"BiYWGNmAuAa50PFaWMc9"};